export enum LoginTypeEnum {
    Credential = "Credential"
}